import * as React from 'react';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { hasIri } from 'src/containers/ProjectDiagram/utils/hasIri';

/**
 * Generates a new unique iri by checking against existing iris on diagram
 * If uniqueness must be considered against non-diagram iris, a set can be
 * optionally passed in as an argument.
 *
 * @param {string} [iris] - Optional set of iris to check uniqueness against
 */
export const useGenerateNewIri = () => {
  const diagram = useDiagram();

  return React.useCallback(
    (iri: string, iris?: Set<string>): string => {
      let value = iri;

      while (diagram && (hasIri(value, diagram.model) || iris?.has(value))) {
        const lastNumMatch = value.match(/(.*)_([0-9]+)$/);
        if (lastNumMatch) {
          const lastNum = Number.parseInt(lastNumMatch[2]);
          value = `${lastNumMatch[1]}_${lastNum + 1}`;
        } else {
          value = `${value}_1`;
        }
      }

      return value;
    },
    [diagram]
  );
};
